// 2020-06-27export { TropaMovimientoReadonlyComponent } from './tropa-movimiento-readonly.component';